module.exports = __webpack_public_path__ + "media/purple-finch-3.ef652730.mp3";